import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import ObtenerPaises from '../functions/ObtenerPaises';
import SancorUbicacionSeleccionar from '../types/SancorUbicacionSeleccionar';
import ObtenerUbicacionesSancor from '../functions/ObtenerUbicacionesSancor';

interface SeleccionarSancorUbicacionProps {
    onChange: (UbicacionSancor: SancorUbicacionSeleccionar) => void;
    onClear: () => void;
    eliminando: boolean;
  }

const SeleccionarSancorUbicacion: React.FC<SeleccionarSancorUbicacionProps> = ({ onChange, onClear, eliminando }) => {


    const [ubicacionesSancor, setUbicacionesSancor] = useState<SancorUbicacionSeleccionar[]>([]);
    const [ubicacionSeleccionada, setUbicacionSeleccionada] = useState<SancorUbicacionSeleccionar | null>({id: 0, zipCode: '', city: '', province: '', location: ''});

    const handleUbicacionChange = (event: React.SyntheticEvent, newValue: SancorUbicacionSeleccionar | null) => {
        if (newValue === null) {
            setUbicacionSeleccionada(null);
            if (onClear) {
                onClear();
            }
            return;
        }
        setUbicacionSeleccionada(newValue);
        if (onChange) {
            onChange(newValue);
        }

        if (newValue === null && onClear) {
            onClear();
        }
        return newValue;
    };

    const fetchUbicacionesSancor = async (query: string): Promise<SancorUbicacionSeleccionar[]> => {
        
        const data = await ObtenerUbicacionesSancor(query);
        return data.ubicaciones_sancor;
    };

    const handleInputChange = (event: React.SyntheticEvent, newValue: string) => {
        // Tengo que traer las ubicaciones de Sancor que contenga el string newValue
        // Espero una respuesta de la api que es asincrona
        // Cuando la respuesta llegue, actualizo el estado de ubicacionesSancor
        if (newValue.length < 3) {
            setUbicacionesSancor([]);
        } else {
            fetchUbicacionesSancor(newValue).then((ubicaciones) => {
                setUbicacionesSancor(ubicaciones);
        })
        }
    };        


    return (
        <div className="flex flex-col w-full ">
            <Autocomplete<SancorUbicacionSeleccionar>
                options={ubicacionesSancor}
                getOptionLabel={(option: SancorUbicacionSeleccionar) => `${option.location}`}
                renderInput={(params) => <TextField {...params} label="Localidad / Provincia" />}
                value={ubicacionSeleccionada}
                onChange={handleUbicacionChange}
                onInputChange={handleInputChange}
                isOptionEqualToValue={(option: SancorUbicacionSeleccionar, value: SancorUbicacionSeleccionar) => option.id === value.id}
                renderOption={(props, option: SancorUbicacionSeleccionar) => (
                <li {...props}>
                    {option.location}
                </li>
                )}
                disabled={eliminando}
                size="small"
                noOptionsText="Por favor ingresá al menos 3 letras"
            />
        </div>
    );
};

export default SeleccionarSancorUbicacion;